import {AfterViewInit, ChangeDetectionStrategy, Component, computed, ElementRef, input, signal, viewChild, ViewChild, ViewEncapsulation} from "@angular/core";
import {ForelderModell, GruppeId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {StrengMalPipe} from "felles-ng2/pipes/StrengMalPipe";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {StrengMaler} from "felles/tjenester/StrengMaler";
import {MatTooltip} from "@angular/material/tooltip";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {gruppefargeNilsikker, GruppeMedFarge} from "felles-ng2/modell/Gruppefarge";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {MatIcon} from "@angular/material/icon";
import {PotensiellForelderModell} from "felles-ng2/tjenester/ressurser/ng2HttpKlientTilleggstyper";
import {TranslateModule} from "@ngx-translate/core";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {erIkkeTomStreng} from "felles-ng2/støttefunksjoner/strenger";

const debug = initDebugger('ForelderstiKomponent');

/** Viser sti til forelder som klikkbar lenke som navigerer til forelder ved klikk */
@Component({
    selector: 'foreldersti',
    templateUrl: 'foreldersti.html',
    styleUrl: 'foreldersti.scss',
    encapsulation: ViewEncapsulation.None,
    host: { //merk at @HostBinding ikke fungerer på input som signal, derfor def her
        '[class.klikkbar]': 'klikkbar()',
        '[class.trunkert]': 'trunkert()',
    },
    imports: [
        StrengMalPipe,
        MatTooltip,
        MatIcon,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForelderstiKomponent {

    forelder = input.required<PotensiellForelderModell>();
    eiendeGruppe = input<GruppeMedFarge | null>(null);
    eiendeGruppeId = input<GruppeId | null>(null);
    stil = input<'full' | 'kort'>('full');
    klikkbar = input(true);
    trunkert = input(false);

    tooltip = signal('');
    fullStiSomRenTekst = computed(() => this.beregnForelderBeskrivelseSomRenTekst())
    gruppe = computed(() => this.eiendeGruppe() ?? erIkkeNil(this.eiendeGruppeId()) ? this.kontekst.autentisertBruker().finnAutentiserteGruppe(this.eiendeGruppeId()!) : null);
    gruppefarge = computed(() => gruppefargeNilsikker(this.gruppe()));

    constructor(private navigasjon: Navigasjon, private kontekst: BrukerkontekstTilbyder, private strengMaler: StrengMaler, private oversettelser: Oversettelser) {
    }

    gaaTilForelder() {
        if (!this.klikkbar()) return;
        this.navigasjon.gåTilEntitetRef(this.forelder().entitetRef!);
    }

    //private hjelpemetoder

    private beregnForelderBeskrivelseSomRenTekst() {
        if (!this.forelder().harForelder) return this.oversettelser.oversett(i18n('ingen forelder'));
        let beskrivelse = this.strengMaler.somFullStreng(this.forelder().beskrivelse!)
          .replace(/<span class=.*?mal-dokument.*?>(.*?)<\/span>/, ' i dokument "$1" ')
          .replace(/<span class=.*?mal-mappe.*?>(.*?)<\/span>/, ' i mappe "$1" ')
          .replace(/<span class=.*?mal-oppgave.*?>(.*?)<\/span>/, ' i oppgave "$1" ')
          .replace(/<span class=.*?mal-beslutning.*?>(.*?)<\/span>/, ' i beslutning "$1" ')
          .replace(/<span class=.*?mal-sak.*?>(.*?)<\/span>/, ' i sak "$1" ')
          .replace(/<span class=.*?mal-moete.*?>(.*?)<\/span>/, ' i $1 ')
          .replace(/<.*?>/g, '') //fjern resterende tagger
          .replace(/\s+/g, ' ') //fjern linjeskift og unødvendige mellomrom
          .trim(); //fjern innledende og sluttende mellomrom

        const gruppeBeskrivelse = erIkkeNil(this.gruppe()) ? this.oversettelser.oversett(i18n('i {gruppe} i {organisasjon}'), {gruppe: this.gruppe()?.tittel, organisasjon: this.gruppe()?.organisasjonsnavn}) : '';
        return beskrivelse + (erIkkeTomStreng(gruppeBeskrivelse) ? ` ${gruppeBeskrivelse}` : '');
    }

}
